module.exports = __webpack_public_path__ + "static/media/quadrados.9c883e7b.png";